import { styled } from '@mui/system';
export const container = {
    marginBottom: '16px',
};
export const imgEshopCommon = (theme) => ({
    maxHeight: '249px',
    width: '100%',
    aspectRatio: '1920 / 250',
    [theme.breakpoints.down('sm')]: {
        maxHeight: '139px',
        aspectRatio: '720 / 140',
    },
});
export const EshopHeaderContainerInfoParent = styled('div')(({ theme, eshopBannerUrlMobile, eshopBannerUrlDesktop, isWithoutBanner }) => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        height: '87px',
        marginTop: eshopBannerUrlMobile && eshopBannerUrlDesktop && !isWithoutBanner ? '-25px' : 'inherit',
        [theme.breakpoints.down('sm')]: {
            height: '122px',
            marginTop: eshopBannerUrlMobile && eshopBannerUrlDesktop && !isWithoutBanner ? '-4%' : 'inherit',
        },
    };
});
export const EshopHeaderContainerInfo = styled('div')(({ theme, isStickyState, eshopBannerUrlMobile, eshopBannerUrlDesktop, isWithoutBanner }) => {
    const defaultStyle = {
        display: 'flex',
        alignItems: 'center',
        background: '#FFFFFF',
        boxShadow: '0px 10px 30px rgb(0 0 0 / 5%)',
        padding: '8px 16px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    };
    const stickyStyle = {
        borderRadius: 0,
        margin: 0,
        width: '100%',
        position: 'fixed',
        top: '0',
        zIndex: 10,
        transition: 'width 0.2s ease-in, border-radius 0.2s 0.3s ease-in',
    };
    const commonDetailEshopStyle = Object.assign(Object.assign({}, defaultStyle), { position: 'absolute', transition: 'width 0.2s ease-out', [theme.breakpoints.up('ew')]: {
            top: '-329',
        } });
    if (!isStickyState) {
        if (!eshopBannerUrlMobile || !eshopBannerUrlDesktop || isWithoutBanner) {
            return Object.assign(Object.assign({}, commonDetailEshopStyle), { width: '100%' });
        }
        else {
            return Object.assign(Object.assign({}, commonDetailEshopStyle), { width: '94%', borderRadius: '8px' });
        }
    }
    else {
        return Object.assign(Object.assign({}, defaultStyle), stickyStyle);
    }
});
export const eshopNameBrand = (theme) => ({
    fontSize: '16px',
    fontFamily: 'RakutenSansUiSemiBold',
    [theme.breakpoints.up('ta')]: {
        fontSize: '24px',
    },
    display: 'flex',
    fontWeight: 600,
    lineHeight: '20px',
    marginRight: '8px',
});
export const containerBadge = {
    position: 'relative',
    display: 'flex',
    marginBottom: '4px',
    alignItems: 'center',
};
export const containerInfo = {
    marginLeft: '16px',
};
export const clickable_area = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: 'inherit',
};
export const eshopHeaderContainerSearch = (theme) => ({
    flex: 1,
    width: '100%',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
        marginTop: '16px',
    },
});
export const inputSize = (theme) => ({
    display: 'inline-flex',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '400px',
        width: '75% !important',
    },
});
export const detailEshopContainer = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
});
export const badge = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '4px',
};
export const textCrew = (theme) => ({
    position: 'absolute',
    top: '15%',
    left: '18%',
    color: '#F53A3A',
    fontSize: '2.6vw',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
});
export const textCrewMobile = (theme) => ({
    top: '35%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('sm')]: {
        display: 'none',
    },
});
// Iso prod
export const textCrewP = {
    margin: 0,
};
export const textRefund = {
    fontWeight: 600,
};
export const containerImgCommon = {
    position: 'relative',
};
export const TextRefund = styled('span')(() => ({
    fontWeight: 600,
}));
